<script setup>
    import { toRef } from 'vue';
    import deleteUser from '../helpers/DeleteUser';
    import Loading from '../components/containers/Loading.vue';
</script>

<template>
    <Loading :isLoading="submitting" :type="'overlay'" :loadText="'Processing...'">
    <div v-if="modalActive" class="fixed w-screen h-screen z-100 top-0 flex justify-center items-center">
        
            <div class="bg-[#111A1C] w-full absolute h-full opacity-40 z-1" @click="closeModal()"></div>
            <div class="bg-white px-4 py-8 z-10 max-w-[578px] w-full absolute text-center rounded-lg">
                <p class="pb-4 leading-[28px]">
                    Are you sure you want to delete this account?
                </p>
                <div class="mb-8 mt-3 inline-block text-left">
                    <span class="block mb-1">Name: <span class="font-medium">{{user.user.firstName}} {{user.user.lastName}}</span></span>
                    <span class="block">Email: <span class="font-medium">{{user.user.email}}</span></span>
                </div>
                <div>
                    <button class="w-[176px] mr-3 bg-grey-50 px-6 py-3 rounded-md" @click="closeModal()">Cancel</button>
                    <button class="w-[176px] bg-orange-500 px-6 py-3 rounded-md text-white" @click="handleDeleteUser()">Delete account</button>
                </div>
            </div>
    </div>
        </Loading>
</template>

<script>
    export default {
    props: ['isActive', 'selectedUser'],
    watch: {
        isActive: function(newVal, oldVal) {
            this.modalActive = newVal;
        },
        selectedUser: function(newVal, oldVal) {
            this.user = newVal;
        }
    },
    created() {
    },
    data() {
        return {
            modalActive: this.isActive,
            user: this.selectedUser,
            submitting: false
        }
    },
    mounted() {
    },
    methods: {
        async handleDeleteUser() {
            this.submitting = true;
            this.$notify({
                title: "User deleted",
                text: "User successfully deleted",
                duration: 5000,
            });
            await deleteUser(this.user.userId, this.user.user);
            this.submitting = false;
            this.$router.go(-1)
        },
        closeModal(success) {
            this.modalActive = false;
            this.$emit('handleModalClose', success);
            document.body.classList.remove('overflow-hidden');
        }
    }
}
</script>

<style lang="scss">

</style>
